import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MediaFilesLibrary from '../../MediaFilesLibrary'

import { getFacebookMediaImages, clearFacebookMediaImages } from '../../../../modules/actions/mediaFiles'
import {
  facebookImagesAfterSelector,
  facebookImagesErrorSelector,
  facebookImagesIsLoadingSelector,
  facebookImagesIsNextSelector,
  facebookImagesWasLoadedSelector,
  facebookMediaImagesSelector
} from '../../../../modules/selectors/mediaFiles'
import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'

const FacebookImageFilesLibrary = props => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const afterImages = useSelector(facebookImagesAfterSelector)

  const loadInitialMediaHandler = useCallback(() => {
    dispatch(
      getFacebookMediaImages({
        account: selectedAdAccountId,
        limit: 12
      })
    )
  }, [dispatch, selectedAdAccountId])

  const loadMoreHandler = useCallback(() => {
    dispatch(
      getFacebookMediaImages({
        account: selectedAdAccountId,
        limit: 12,
        after: afterImages
      })
    )
  }, [dispatch, selectedAdAccountId, afterImages])

  const clearVideosHandler = useCallback(() => {
    dispatch(clearFacebookMediaImages())
  }, [dispatch])

  return (
    <MediaFilesLibrary
      type="image"
      mediaThumbnailFieldName="url_128"
      mediaFilesSelector={facebookMediaImagesSelector}
      mediaFilesIsLoadingSelector={facebookImagesIsLoadingSelector}
      mediaFilesErrorSelector={facebookImagesErrorSelector}
      mediaFilesWasLoadedSelector={facebookImagesWasLoadedSelector}
      mediaFilesNextSelector={facebookImagesIsNextSelector}
      loadInitialMediaHandler={loadInitialMediaHandler}
      loadMoreHandler={loadMoreHandler}
      clearMediaHandler={clearVideosHandler}
      {...props}
    />
  )
}

export default FacebookImageFilesLibrary
